import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ReservationBookingEngine } from "../../Services/Service";

export const getBookingEngineUrl = createAsyncThunk(
    "bookingEngine/getBookingEngineUrl",
    async (PID, { rejectWithValue }) => {
        try {
            const response = await ReservationBookingEngine(PID);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const bookingEngineSlice = createSlice({
    name: "bookingEngine",
    initialState: {
        bookingUrl: "",
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBookingEngineUrl.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getBookingEngineUrl.fulfilled, (state, action) => {
                state.loading = false;
                state.bookingUrl = action.payload; // direct string
            })
            .addCase(getBookingEngineUrl.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default bookingEngineSlice.reducer;